import React, { useCallback, useState, type FC } from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { Box, xcss } from '@atlaskit/primitives';
import { useActions } from '../../controllers/conversation-store';
import { LazyClearConversationModal } from './clear-conversation-modal/async';
import messages from './messages';

export const ClearConversation: FC = () => {
    const { clearConversation } = useActions();
    const { formatMessage } = useIntl();

    const [showClearConversationModal, setShowClearConversationModal] = useState(false);
    const openModal = useCallback(() => setShowClearConversationModal(true), []);
    const closeModal = useCallback(() => setShowClearConversationModal(false), []);

    const handleClearButtonClick = useCallback(() => {
        clearConversation();
        closeModal();
    }, [clearConversation, closeModal]);

    return (
        <Box xcss={buttonStyles}>
            <Button onClick={openModal}>{formatMessage(messages.virtualAgentClearConversationButton)}</Button>
            <ModalTransition>
                {showClearConversationModal && (
                    <LazyClearConversationModal onClose={closeModal} onClearButtonClick={handleClearButtonClick} />
                )}
            </ModalTransition>
        </Box>
    );
};

const buttonStyles = xcss({
    alignSelf: 'flex-end',
});
